import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["formField", "showAllOptions", "handleOnDrag", "handleUpdate", "TableHeader", "addOption", "disableAddOption", "renderDisableAddOptionReason", "labelWidth"];
import { useState, useEffect, useContext } from 'react';
import { Table } from 'foundations-components/transitional/components/Table';
import { sanitize } from 'sanitize-text/sanitizers/Sanitize';
import { config } from 'sanitize-text/sanitizers/SanitizeConfiguration';
import { handleRemoveOption } from './utils/removeOption';
import { addPreselectedOption } from './utils/updatePreselectedOptions';
import { onReorder } from './utils/onReorder';
import { handleDrop } from './utils/handleDrop';
import OptionsTableHeader from './OptionsTableHeader';
import { handleUpdateLabel } from './utils/updateOptionsLabel';
import OptionsTableDraggableRow from './OptionsTableDraggableRow';
import { handleShowingOptions } from './utils/handleShowingOptions';
import OptionsTableActions from './OptionsTableActions';
import TrackingContext from 'ui-forms-components/contextProviders/TrackingContext';
import { FIELD_OPTIONS } from 'ui-forms-components/constants/TrackingEvents';
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { jsxs as _jsxs } from "react/jsx-runtime";
const OptionsTable = _ref => {
  let {
      formField,
      showAllOptions = false,
      handleOnDrag = () => {},
      handleUpdate = () => {},
      TableHeader = OptionsTableHeader,
      addOption,
      disableAddOption,
      renderDisableAddOptionReason,
      labelWidth = '300px'
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    track
  } = useContext(TrackingContext);
  const [options, setOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  useEffect(() => {
    handleShowingOptions({
      formField,
      showAllOptions,
      setOptions,
      setSelectedOptions
    });
  }, [formField, showAllOptions]);
  const onDrop = () => {
    handleDrop({
      options,
      formField,
      handleUpdate
    });
    track(FIELD_OPTIONS.REORDERED_ROW);
  };
  const onRemove = idx => {
    handleRemoveOption({
      idx,
      options: formField.options,
      formField,
      selectedOptions,
      handleUpdate,
      setOptions,
      setSelectedOptions
    });
    track(FIELD_OPTIONS.REMOVED_ROW);
  };
  const updatePreselected = value => {
    addPreselectedOption({
      formField,
      value,
      handleUpdate
    });
    track(FIELD_OPTIONS.UPDATED_PRESELECTED);
  };
  const updateLabel = (idx, value) => {
    handleUpdateLabel({
      formField,
      value,
      updateCallback: handleUpdate,
      idx
    });
    track(FIELD_OPTIONS.UPDATED_LABEL);
  };
  return /*#__PURE__*/_jsxs(Table, {
    condensed: true,
    flush: true,
    "data-test-id": "options-table",
    children: [/*#__PURE__*/_jsx(TableHeader, Object.assign({}, props)), /*#__PURE__*/_jsxs("tbody", {
      children: [options.map((option, idx) => /*#__PURE__*/_createElement(OptionsTableDraggableRow, Object.assign({}, props, {
        onDrop: onDrop,
        key: option.value,
        label: sanitize(option.label, config.HTML),
        value: option.value,
        onDrag: handleOnDrag,
        fieldType: formField.fieldType,
        onRemove: () => onRemove(idx),
        labelWidth: labelWidth,
        onReorder: onReorder({
          options,
          setOptions
        }),
        selectedOptions: selectedOptions,
        displayOrder: option.displayOrder,
        updatePreselected: value => updatePreselected(value),
        updateLabel: ({
          target: {
            value
          }
        }) => updateLabel(idx, sanitize(value, config.HTML))
      }))), /*#__PURE__*/_jsx(OptionsTableActions, {
        addOption: addOption,
        disableAddOption: disableAddOption,
        renderDisableAddOptionReason: renderDisableAddOptionReason,
        formField: formField,
        handleUpdate: handleUpdate
      })]
    })]
  });
};
export default OptionsTable;